var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke-fill",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stroke",
    cx: 38.5,
    cy: 38.5,
    r: 36,
    stroke: "#5FB4D9",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#deaf_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M25.71 50.1286C25.71 51.1125 26.1009 52.056 26.7965 52.7517C27.4922 53.4474 28.4358 53.8382 29.4196 53.8382C29.9068 53.842 30.3896 53.7472 30.8392 53.5596C31.6559 53.0963 32.3624 52.4613 32.91 51.6985C33.4576 50.9357 33.8332 50.0632 34.0109 49.1412C34.836 46.8444 36.3985 44.8854 38.4543 43.5702C40.2253 42.3578 41.6947 40.7556 42.7498 38.8866C43.6918 37.223 44.2109 35.3535 44.2616 33.4424C44.2266 31.0054 43.2339 28.6801 41.4981 26.9692C39.7624 25.2582 37.4231 24.2991 34.9858 24.2991C32.5486 24.2991 30.2093 25.2582 28.4735 26.9692C26.7378 28.6801 25.7451 31.0054 25.71 33.4424H22.0005C22.0005 29.9982 23.3687 26.6951 25.8041 24.2597C28.2395 21.8243 31.5426 20.4561 34.9868 20.4561C38.431 20.4561 41.7341 21.8243 44.1695 24.2597C46.6049 26.6951 47.9731 29.9982 47.9731 33.4424C47.9201 35.9797 47.2418 38.4647 45.9983 40.6771C44.6979 42.9978 42.8908 44.9953 40.7115 46.5209C39.2564 47.394 38.1363 48.7299 37.5303 50.315C37.1983 51.7066 36.5764 53.0126 35.7051 54.1474C34.8338 55.2821 33.7328 56.2203 32.4741 56.9003C31.5156 57.3363 30.4745 57.5611 29.4215 57.5593C27.4541 57.5567 25.568 56.7741 24.1769 55.3829C22.7857 53.9917 22.003 52.1056 22.0005 50.1382H25.71V50.1286Z",
    fill: "#5FB4D9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M46.7959 21.6242L49.4201 19C53.2451 22.8293 55.3936 28.0204 55.3936 33.4329C55.3936 38.8453 53.2451 44.0364 49.4201 47.8657L46.7959 45.2416C49.924 42.1081 51.6808 37.8614 51.6808 33.4338C51.6808 29.0062 49.924 24.7596 46.7959 21.6261V21.6242Z",
    fill: "#5FB4D9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M39.6264 33.4328C39.6264 34.35 39.3544 35.2466 38.8449 36.0093C38.3353 36.7719 37.611 37.3663 36.7636 37.7173C35.9163 38.0683 34.9838 38.1601 34.0843 37.9811C33.1847 37.8022 32.3584 37.3605 31.7098 36.712C31.0613 36.0634 30.6196 35.2371 30.4407 34.3375C30.2617 33.438 30.3536 32.5055 30.7046 31.6582C31.0556 30.8108 31.65 30.0865 32.4126 29.577C33.1752 29.0674 34.0718 28.7954 34.989 28.7954C36.2187 28.7959 37.398 29.2847 38.2676 30.1542C39.1371 31.0238 39.6259 32.2031 39.6264 33.4328Z",
    fill: "#5FB4D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "deaf_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    width: 33.3937,
    height: 38.5498,
    fill: "white",
    transform: "translate(22 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeaf);
export default __webpack_public_path__ + "static/media/deaf.ff46e0938e43dd2a2e9395eb11887f39.svg";
export { ForwardRef as ReactComponent };